/**
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {Popup} popup
 * @constructor
 */
export let Badge = function (config, library, popup) {

  // todo: Зафиксировать положения беджа на бекеэнде в Enum

  /**
   * @type {string}
   */
  let template = `
<div class="slp-badge {{positionClass}}">
    {{#balance}}
        <div class="slp-badge-balance"><span>{{balance}}</span></div>
    {{/balance}}
    <div class="slp-badge-title"><span>{{title}}</span></div>
</div>`;

  /**
   * @type {{balance: int}}
   */
  let customer = config.getCustomer();

  /**
   * @type {*}
   */
  let badgeTexts = config.getTexts().badge;

  /**
   * @type {{}}
   */
  const POSITION_CLASSES = {
    top_left_vert: 'top-left-vert',
    bottom_left_vert: 'bottom-left-vert',
    bottom_left_hor: 'bottom-left-hor',
    bottom_right_hor: 'bottom-right-hor',
    bottom_right_vert: 'bottom-right-vert',
    top_right_vert: 'top-right-vert'
  };

  /**
   * @type {HTMLElement}
   */
  let badgeElement;

  /**
   *
   */
  let init = () => {
    badgeElement = document.createElement('div');
    badgeElement.className = 'slp-badge-wrapper';
    badgeElement.innerHTML = library.mustache().render(
      config.customization().badgeTemplate || template,
      {
        positionClass: POSITION_CLASSES[config.getBadgePosition()],
        title: badgeTexts.title,
        balance: customer.balance
      }
    );
    document.body.appendChild(badgeElement);
    this.hide();

    library.addEventListener(badgeElement, 'click', () => {
      this.showPopup();
    });
  };

  /**
   *
   */
  this.show = function () {
    badgeElement.style.display = '';
    config.customization().onBadgeShown(this);
  };

  /**
   *
   */
  this.showPopup = function () {
    popup.show();
  };

  /**
   *
   */
  this.hide = function () {
    badgeElement.style.display = 'none';
  };

  /**
   * @return {{badge: HTMLElement}}
   */
  this.getDomElements = function () {
    return {
      badge: badgeElement
    };
  };

  init();
};